/**
 * @generated SignedSource<<b36b64bf56162aeae9847c6b9d5622c4>>
 * @relayHash 7430b3e713f48209533b4c2cbdbd1515
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f92753f274185647bb7ca2f2fd590f76e5c9f6c7138a64b2a8acd0d575c89c9f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PRDetailsPopupViewQuery } from './PRDetailsPopupViewQuery.graphql';

const node: PreloadableConcreteRequest<PRDetailsPopupViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f92753f274185647bb7ca2f2fd590f76e5c9f6c7138a64b2a8acd0d575c89c9f",
    "metadata": {},
    "name": "PRDetailsPopupViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
